<div class="login-page">
  <div
    *ngIf="!isModernBrowser && !isMobileView"
    class="unsupported-browser-message"
  >
    <div class="logo">
      <img
        src="../../../assets/LMAX-Exchange-horizontal-logo.svg"
        alt="FXHP-Logo"
      />
    </div>
    <div class="title">Unsupported Browser</div>
    <div class="body">
      It appears that you're using an unsupported browser. Please use one of the
      following modern browsers for the full FX HedgePool experience.
    </div>
    <div class="supported-browsers">
      <div class="supported-browser">
        <div class="browser-icon chrome"></div>
        <div>Chrome</div>
      </div>
      <div class="supported-browser">
        <div class="browser-icon edge"></div>
        <div>Edge</div>
      </div>
      <div class="supported-browser">
        <div class="browser-icon firefox"></div>
        <div>Firefox</div>
      </div>
    </div>
    <div class="contact-support">
      Contact support if you're using a modern browser and still having issues.
      <br />
      <a href="mailto:exchange.support@lmax.com"
        >exchange.support&#64;lmax.com</a
      >
    </div>
  </div>

  <div *ngIf="isMobileView" class="unsupported-device-message">
    <div class="logo">
      <img
        src="../../../assets/LMAX-Exchange-horizontal-logo.svg"
        alt="FXHP-Logo"
      />
    </div>
    <div class="title">Use Larger Screen</div>
    <img
      class="expand-window-icon"
      src="../../../assets/expand-window.svg"
      alt="Expand Window"
    />
    <div class="body">
      1) Please use a larger screen or expand your browser window
    </div>
    <div class="body">2) Refresh the page</div>
    <div class="body">3) Start enjoying the full FX HedgePool experience</div>
  </div>
  <div class="user-login-card-container">
    <mat-card *ngIf="isModernBrowser && !isMobileView" class="user-login-card">
      <div class="login-logo">
        <img
          src="../../../assets/LMAX-Exchange-horizontal-logo.svg"
          alt="FXHP-Logo"
        />
      </div>

      <login-form #login [routeProvided]="routeProvided"> </login-form>

      <mat-spinner *ngIf="isLoading"></mat-spinner>
    </mat-card>
  </div>
  <a href="mailto:exchange.support@lmax.com" class="mail-support"
    >exchange.support&#64;lmax.com</a
  >
</div>
